var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43529 6.74588C6.09019 7.58706 4.65372 8.17372 3.89451 8.93294C2.13451 10.6929 2.6047 13.9455 4.41647 14.571C6.08588 15.1404 4.50705 12.1122 6.08588 10.7965C7.7596 9.51529 12.069 11.7541 8.61372 14.6745C7.80274 15.2698 7.68196 15.4682 7.15568 15.9945C4.32588 18.8243 8.91568 22.0294 12.2761 21.6196C15.2525 21.2573 16.0678 19.3031 16.482 16.5208C16.8573 13.9843 16.3525 13.1 16.7451 11.258C18.009 7.76823 22.0941 10.7404 22.6678 12.4314C22.6808 12.2373 22.698 12.0475 22.698 11.849C22.698 5.86157 17.8408 1 11.8447 1C8.41098 1 5.35686 2.60039 3.37255 5.08941C5.66313 3.66157 7.14705 5.02471 6.43529 6.74588Z",
    fill: "url(#paint0_radial_3925_20161)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6051 13.6234C16.5745 12.8575 16.5473 12.1763 16.7451 11.2582C18.009 7.76842 22.0898 10.7406 22.6722 12.4359C22.3702 18.1559 17.651 22.7068 11.849 22.7068C5.85725 22.7068 1 17.8453 1 11.8535C1 9.29548 1.88863 6.94881 3.37255 5.09391C5.66314 3.66175 7.14706 5.02489 6.43529 6.74607C6.2277 7.25586 5.61189 7.67281 4.99063 8.09346C4.59205 8.36333 4.19123 8.63472 3.89451 8.93312C2.13451 10.6931 2.60471 13.9457 4.41647 14.5712C5.26602 14.8609 5.27437 14.219 5.28574 13.3452C5.29672 12.502 5.31051 11.4428 6.08588 10.7967C7.75529 9.51548 12.069 11.7543 8.61373 14.6747C7.98641 15.1352 7.77207 15.3582 7.46358 15.6792C7.37326 15.7731 7.27487 15.8755 7.15569 15.9947C4.32588 18.8245 8.91569 22.0296 12.2761 21.6198C15.2525 21.2574 16.0722 19.3076 16.482 16.521C16.6702 15.2509 16.636 14.3943 16.6051 13.6234ZM19.1003 8.05744C18.5999 8.75626 17.3575 8.7045 16.3179 7.95822C15.2826 7.20763 14.8469 6.0343 15.343 5.33979C15.8434 4.64528 17.0944 4.69273 18.1297 5.44763C19.165 6.1896 19.605 7.36293 19.1003 8.05744Z",
    fill: "url(#paint1_radial_3925_20161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3925_20161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4013 7.16378) scale(14.4135 14.9549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF402F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2057,
    stopColor: "#E0382B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#C42225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#BE1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1113"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3925_20161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5075 6.55898) scale(14.0625 11.8181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A9297"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/유진투자증권-24.f4a96e1ebe0120a2b84f48dcb6d3abb1.svg";
export { ForwardRef as ReactComponent };